import React from "react";
import { Link } from "@tanstack/react-router";
import { Card } from "@tennr/frontend/components/Card";
import { DynamicText } from "@tennr/frontend/components/DynamicText";
import "./CaseStudyCard.css";

export interface CaseStudyCardProps {
  logo: string;
  title: string;
  company: string;
  slug: string;
}

export const CaseStudyCard: React.FC<CaseStudyCardProps> = ({ logo, title, company, slug }) => {
  return (
    <Card className="case-study-card">
      {logo && (
        <div className="case-study-card-logo">
          <img
            src={logo}
            alt={company}
            onError={(e) => {
              // Hide the entire logo container if image fails to load
              const logoContainer = (e.target as HTMLImageElement).parentElement;
              if (logoContainer) {
                logoContainer.style.display = "none";
              }
            }}
            draggable={false}
          />
        </div>
      )}

      <DynamicText as="h4" className="case-study-card-title">
        <Link to={`/customer-stories/${slug}`}>
          {title}
          <span className="case-study-card-tappable-area"></span>
        </Link>
      </DynamicText>

      <DynamicText as="p" className="case-study-card-cta">
        READ CASE STUDY
      </DynamicText>
    </Card>
  );
};
